// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4402":"93b6836a","6036":"6a42f7d4","6703":"8aac89da","7280":"968f4dca"}[chunkId] + ".chunk.css";
};